import Controller from "@/modules/viewmodel/class/Controller";
import Sequelize from "@/modules/viewmodel/class/Sequelize/Sequelize";
import loader from "./loader";
const { initModel, initController, initService, initRoutes } = loader;

class ViewModel {
  constructor() {
    this.Sequelize = Sequelize;
    this.model = new Sequelize();

    this.model = initModel(this);
    this.service = initService(this);
    this.controller = initController(this);
    this.router = initRoutes(this);
  }
}

ViewModel.prototype.Controller = Controller;

export default ViewModel;
